export type ConnectivityProbeOptions = {
  fetcher?: typeof fetch;
  timeoutMs?: number;
};

/** Probe the application origin instead of trusting navigator.onLine. */
export async function isAppReachable({
  fetcher = fetch,
  timeoutMs = 5000,
}: ConnectivityProbeOptions = {}): Promise<boolean> {
  const controller = new AbortController();
  const timeout = globalThis.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetcher("/health", {
      cache: "no-store",
      credentials: "same-origin",
      signal: controller.signal,
    });
    return response.ok;
  } catch {
    return false;
  } finally {
    globalThis.clearTimeout(timeout);
  }
}
